<div class="payment-wrapper" [class.light-theam]="isLightTheam"  dir="ltr">
    <ul >
        <li *ngFor="let installment of sliderAmount; let first = first; let last = last; let index = index" class="payment-plan" [class.islast]="last">
            <div [class.right-10]="textDirection == 'rtl'">
                <ng-container *ngIf="first;  else installmentIcon">
                    <img [src]="isLightTheam ? 'assets/images/Instalment-'+index+'.svg' : 'assets/images/Instalments-'+index+'.svg' " alt="Installment Plan {{index}}">
                </ng-container>
                <ng-template #installmentIcon>
                    <img [src]="isLightTheam ? 'assets/images/Instalment-'+(index+1)+'.svg' : 'assets/images/Instalments-'+index+'.svg'" alt="Installment Plan 4">
                </ng-template>
                <span [class.isFirst]="first">  {{installment.label}} </span>
            </div>
            <span [class.isFirst]="first">
                {{ 'KD' | translate}}  {{ installment?.amount  | number:'1.3-3'}}
            </span>
        </li>

    </ul>
    <hr [class.ml-0]="textDirection == 'rtl'">
    <div class="total cust-total" >
        <div  [class.pl-40]="textDirection == 'rtl'">
            <span class="amount"> {{ 'SHARIA_INTEREST' | translate }}</span>
        </div>
        <span class="amount" translate>
            HOME_PAGE.TOTAL_COST <span>{{ 'KD' | translate}}  {{orderAmount| number:'1.3-3'}}</span> 
        </span>
    </div>
</div>